import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import {generateRoutePath} from '@epic-core/common';

const TutorialMod = ({data, type}) => {
    if (!data.length) return;
    const tutorialItem = (item) => {
        const {headerImage, tutorial = {}, _urlPattern} = item;
        const {completionTime, name, objective = []} = tutorial;
        return (
            <div className="mod-tutorial col-xs-12 col-md-6 col-lg-4" key={name}>
                <Link className="tutorial-box" to={generateRoutePath(_urlPattern)}>
                    <div className="tutorial-image">
                        <img src={headerImage} alt={name} />
                    </div>
                    <div className="tutorial-content">
                        <div className="time-indicator">{completionTime}</div>
                        <h4>{name}</h4>
                        <ul className="list objectiveList">
                            {objective.map(({completionDisplayName}) => <li key={completionDisplayName}><span>{completionDisplayName}</span></li>)}
                        </ul>
                    </div>
                </Link>
            </div>
        )
    }
    
    return (
        <div className="tutorial-mod-list" id={type}>
            { data.map((item, i) => tutorialItem(item)) }
        </div>
        
    )
}

TutorialMod.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            headerImage: PropTypes.string,
            tutorial: PropTypes.shape(),
            _urlPattern: PropTypes.string
        })
    ),
    type: PropTypes.string
}

export default TutorialMod
